// extracted by mini-css-extract-plugin
export default {"link":"HomeBoardCard_link__SgrX4","card":"HomeBoardCard_card__EpY7x","name":"HomeBoardCard_name__BB4Yz","desc":"HomeBoardCard_desc__uwEvM","notLogin":"HomeBoardCard_notLogin__HNImj"};